import BasicResource from '@/api/resource';

class SKAdNetworkResource extends BasicResource {
    constructor () {
        super('skad-networks');
    }
}

export default new SKAdNetworkResource;
